<template>
  <ul class="library-list bg-bgDefault">
    <slot />
  </ul>
</template>

<style lang="less" scoped>
.library-list {
  border: 1px solid rgb(var(--v-theme-strokeDefault));
  padding: 0px;
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  list-style-type: none;
  overflow: hidden;
  margin-bottom: 24px;
}
</style>
